import { formatTitleCase } from './formatTitleCase'

type Props = { city?: string | null | undefined; state?: string | null | undefined } | null | undefined

export const formatCityState = (location: Props): string => {
    if (!location) {
        return ''
    }

    const { city, state } = location

    if (!city && !state) {
        return ''
    }

    const isCityAllCaps = city === city?.toUpperCase()

    const formattedCity = city ? formatTitleCase(isCityAllCaps ? city.toLowerCase() : city) : ''
    const formattedState = state ? state.replace(/\./g, '').toUpperCase() : ''

    if (formattedCity && formattedState) {
        return `${formattedCity}, ${formattedState}`
    }

    if (formattedCity) {
        return formattedCity
    }

    return formattedState
}
